import { onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase-config";
import { useNavigate } from "react-router-dom";
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, orderBy, query, setDoc, where } from "firebase/firestore";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from '../redux/userReducer'
import { averageArray, getFirebaseDocs, randomString } from '../common'
import Header from '../components/Header'
// import Tabs from "../components/Tabs";
// import Input from "../components/Input";
// import MyDropzone from "../components/MyDropzone";
import { useUserDetailsMutation, useUsersMutation } from "../redux/apiReducer";
import { format } from "date-fns";
import { FixedSkills } from "../constants";
import Table from "../components/Table";

const Dashboard = () => {

    const [loading, setLoading] = useState(false)
    const [users, setUsers] = useState([])
    const [serverError, setServerError] = useState('')
    const [viewUser, setViewUser] = useState()
    const [analyticsCounter, setAnalyticsCounter] = useState({
        join: 0,
        invite: 0
    })
    const userInfo = useSelector(state => state.user.user)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [finalRatings, setFinalRatings] = useState([])
    const [rawRatings, setRawRatings] = useState([])
    const [links, setLinks] = useState([])
    const [proxyCurlDataProcessed, setProxyCurlDataProcessed] = useState()
    const [statsBackupRaw, setStatsBackupRaw] = useState([])
    const [statsBackup, setStatsBackup] = useState()  //Used to compare is rating is added to dashboard.

    const [fetchUsers, { data: usersData, error: usersError }] = useUsersMutation()
    const [fetchUserDetails, { data: userDetailsData, error: userDetailsError }] = useUserDetailsMutation()

    // console.log('users', users)


    useEffect(() => {
        if (serverError) {
            // Toast.show({ type: 'error', text1: 'Error', text2: serverError })
            setServerError('')
        }
    }, [serverError])

    useEffect(() => {
        if (viewUser) {
            fetchUserDetails(viewUser.userId)
        }
    }, [viewUser])

    useEffect(() => {
        if (usersData) {
            // console.log('usersData', usersData)
            if (usersData.err) {
                setServerError(usersData.err)
                return
            }
            if (usersData.data) {
                setUsers(usersData.data)
            }
        }
    }, [usersData])


    useEffect(() => {
        if (usersError) {
            console.error('usersError', usersError)
            if (usersError.data && usersError.data.err) {
                setServerError(usersError.data.err)
            }
        }
    }, [usersError])

    useEffect(() => {
        if (userDetailsData) {
            // console.log('userDetailsData', userDetailsData)
            if (userDetailsData.err) {
                setServerError(userDetailsData.err)
                return
            }
            if (userDetailsData.data) {
                console.log(userDetailsData.data)
                setFinalRatings(userDetailsData.data.final)
                setRawRatings(userDetailsData.data.raw)
                setLinks(userDetailsData.data.links)
                setProxyCurlDataProcessed(userDetailsData.data.ProxyCurlDataProcessed)
                setStatsBackupRaw(userDetailsData.data.StatsBackupRaw || [])
                setStatsBackup(userDetailsData.data.StatsBackup)
            }
        }
    }, [userDetailsData])


    useEffect(() => {
        if (userDetailsError) {
            console.error('userDetailsError', userDetailsError)
            if (userDetailsError.data && userDetailsError.data.err) {
                setServerError(userDetailsError.data.err)
            }
        }
    }, [userDetailsError])

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                const uid = user.uid
                getUserInfo(uid)
            } else {
                // User is signed out
                navigate('/login')
                // ...
            }
        })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        if (userInfo) {
            // console.log(userInfo)
            fetchUsers()
            getWebAnalytics()
        }
    }, [userInfo])

    const getWebAnalytics = async () => {
        const joinData = (await getDoc(doc(db, 'analytics', 'web-join'))).data()
        const inviteData = (await getDoc(doc(db, 'analytics', 'web-invite'))).data()

        setAnalyticsCounter({
            join: joinData.count,
            invite: inviteData.count
        })
    }

    const getUserInfo = async (uid) => {
        // console.log('uid', uid)
        setLoading(true)
        const userData = await (await getDoc(doc(db, 'staff-users', uid))).data()
        if (!userData) {
            toast.error('User doesn\'t exist. Taking you to login page.')
            setLoading(false)
            setTimeout(async () => {
                await signOutUser()
                navigate('/login')
            }, 3000)
            return
        }
        dispatch(setUser({ ...userData, id: uid }))
        // fetchCategories()
    }

    const signOutUser = async () => {
        await auth.signOut();
    }



    const groupByKpi = () => {
        let groupRatings = []
        for (let rowRating of finalRatings) {
            for (let row of rowRating.ratings) {
                const existsInTempIndex = groupRatings.findIndex(({ name }) => name === row.name)
                if (existsInTempIndex >= 0) {
                    groupRatings[existsInTempIndex] = { ...groupRatings[existsInTempIndex], value: [...groupRatings[existsInTempIndex].value, row.value] }
                } else {
                    groupRatings.push({ name: row.name, value: [row.value], lastDate: row.date })
                }
            }
        }
        return groupRatings
    }


    const findExperienceText = value => {
        const experienceTiles = [
            { name: 'Top-Notch', multiplier: 1 },
            { name: 'Solid Effort', multiplier: 0.75 },
            { name: 'Keep Going', multiplier: 0.5 },
            { name: 'Work in Progress', multiplier: 0.25 },
        ]

        const matchingExp = experienceTiles.find(r => r.multiplier === value)
        if (matchingExp) {
            return matchingExp.name
        }
        return ''
    }

    const checkIfRatingIncludedInStatsBackup = (rating) => {
        if (statsBackup && statsBackup.ratingsReceived && statsBackup.ratingsReceived.length > 0) {
            const matchingRating = statsBackup.ratingsReceived.find(r => r.userId === rating.userId)
            if (matchingRating && !matchingRating.updated) {
                return 'Yes'
            }
        }

        return 'No'
    }

    return <div className="container">
        <Header />
        <div style={{ width: '200px', marginBottom: '20px' }}>
            <table>
                <tbody>
                    <tr>

                        <th>Join Count</th>
                        <td>{analyticsCounter.join}</td>
                    </tr>
                    <tr>
                        <th>Invite Count</th>
                        <td>{analyticsCounter.invite}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        {!viewUser && <Table headers={<thead>
            <th>
                Date Joined
            </th>
            <th>
                Id
            </th>
            <th>
                First Name
            </th>
            <th>
                Last Name
            </th>
            <th>
                Email
            </th>
            <th>
                Industry
            </th>
            <th>
                Profile Pic
            </th>
            <th>
                Phone No
            </th>
            <th>
                Location
            </th>
            <th>
                User Status
            </th>
            <th>
                Guest User
            </th>
            <th>
                Profile Creation Method
            </th>
            <th>
                Profile Creation Ts
            </th>
            <th>
                LinkedIn Url
            </th>
            <th>
                Has Text Company
            </th>
            <th>
                Active Links
            </th>
            <th>
                Pending Links
            </th>
            <th>
                Last Link Ts
            </th>
            <th>
                Ratings Given (No. of users)
            </th>
            <th>
                Last Rating Given Ts
            </th>
            <th>
                Ratings Received (No. of users)
            </th>
            <th>
                Last Rating Received Ts
            </th>
            <th>
                Custom Kpi
            </th>
            <th>
                Dashboard Status
            </th>
            <th>
                Dashboard Updated Ts
            </th>
            <th>
                Unverified Companies
            </th>
            <th>
                Customer Facing
            </th>
            <th>
                PDF Download Ts
            </th>
            <th>
                PDF Records Count
            </th>
            <th>
                App Open Ts
            </th>
            <th>
                Job Change
            </th>
            <th>
                Avg Rating Visible Status
            </th>
            <th>
                Dashboard Visible Status
            </th>
            <th>
                Link Visible Status
            </th>
            <th>
                Platform
            </th>
            <th>
                Deleted Date
            </th>
        </thead>} rows={
            users.map(r => <tr key={r.userId}>
                <td>{!r.deleted && format(new Date(r.created * 1000), 'yyyy/MM/dd')}</td>
                <td className="hover" style={{ color: 'green' }} onClick={() => setViewUser(r)}>{r.userId}</td>
                <td>{r.firstName}</td>
                <td>{r.lastName}</td>
                <td>{r.email}</td>
                <td>{r.occupation}</td>
                <td>{r.profilePic && <img src={r.profilePic} style={{ width: '40px', height: '40px' }} />}</td>
                <td>{r.phone}</td>
                <td>{r.location}</td>
                <td>{r.deleted ? 'Deleted User' : r.status}</td>
                <td>{!r.location ? 'Guest' : 'Active Profile'}</td>
                <td>{ }</td>
                <td>{r.userCompletedProfileTs ? format(new Date(r.userCompletedProfileTs), 'yyyy/MM/dd') : '-'}</td>
                <td>{r.url || '-'}</td>
                <td>{r.experience && r.experience.find(p => !p.orgId || p.orgId === 'text') ? 'Yes' : '-'}</td>
                <td>{r.links.filter(r => r.status !== 'pending').length}</td>
                <td>{r.links.filter(r => r.status === 'pending').length}</td>
                <td>{r.links.length > 0 && format(new Date(r.links.find((r, idx) => idx === 0).created * 1000), 'yyyy/MM/dd hh:mm a')}</td>
                <td>{r.ratingsGiven.length}</td>
                <td>{r.ratingsGiven.length > 0 && format(new Date(r.ratingsGiven.find((r, idx) => idx === 0).date), 'yyyy/MM/dd hh:mm a')}</td>
                <td>{r.ratingsReceived.length}</td>
                <td>{r.ratingsReceived.length > 0 && format(new Date(r.ratingsReceived.find((r, idx) => idx === 0).date), 'yyyy/MM/dd hh:mm a')}</td>
                <td>{r.skills.filter(s => s.isKpi).length - 10}</td>
                <td>{r.avgRating && r.avgRating > 0 ? 'yes' : 'no'}</td>
                <td>{r.avgRatingUpdated && format(new Date(r.avgRatingUpdated), 'yyyy/MM/dd hh:mm a')}</td>
                <td>{r.experience.filter(r => !r.endDate && !r.verified && r.orgId && r.orgId !== 'text').map(r => r.organization).join(', ')}</td>
                <td>{r.isCustomerFacing ? 'Yes' : 'No'}</td>
                <td>{r.pdfDownloadTs ? format(new Date(r.pdfDownloadTs), 'yyyy/MM/dd') : ''}</td>
                <td>{r.reports ? r.reports.length : ''}</td>
                <td>{r.lastActiveTs ? format(new Date(r.lastActiveTs), 'yyyy/MM/dd hh:mm a') : '-'}</td>
                <td>{r.activelyLookingJobChange ? 'Yes' : 'No'}</td>
                <td>{r.avgRatingCommunity ? 'Community' : ''} {r.avgRatingLinks ? 'Links' : ''}</td>
                <td>{r.dashboardCommunity ? 'Community' : ''} {r.dashboardLinks ? 'Links' : ''}</td>
                <td>{r.relationshipCommunity ? 'Community' : ''} {r.relationshipLinks ? 'Links' : ''}</td>
                <td>{r.platform || '-'}</td>
                <td>{r.deleted && r.deletedDate && format(new Date(r.deletedDate), 'yyyy/MM/dd')}</td>
            </tr>)} />}
        {viewUser && <>
            <p className="hover" onClick={() => setViewUser()}>{'<- Back'}</p>
            <h2>{viewUser.firstName} {viewUser.lastName}</h2>

            <h3>KPI</h3>

            <Table

                headers={<thead>
                    <th>Name</th>
                    <th>Is Kpi</th>
                    <th>Custom</th>
                </thead>}

                rows={viewUser.skills.slice().sort((a, b) => (a.isKpi > b.isKpi) ? -1 : 1).map((r, index) => <tr key={r.skill + index}>
                    <td>{r.skill}</td>
                    <td>{r.isKpi ? 'KPI' : 'Skills'}</td>
                    <td>{FixedSkills.includes(r.skill) ? 'No' : r.isKpi ? 'Yes' : '-'}</td>
                </tr>
                )}
            />

            <h3>Rated KPI</h3>
            <Table
                headers={<thead>
                    <th>Name</th>
                    <th>Ratings Received</th>
                    <th>Avg Rating</th>
                    <th>Last Date</th>
                </thead>}

                rows={groupByKpi().map(rating => <tr key={rating.name}>
                    <td>{rating.name}</td>
                    <td>{rating.value.length}</td>
                    <td>{averageArray(rating.value).toFixed(2)}</td>
                    <td>{format(new Date(rating.lastDate), 'yyyy/MM/dd')}</td>
                </tr>)}

            />

            <h3>Company Details</h3>


            <Table
                headers={<thead>
                    <th>Company Name</th>
                    <th>Job Title</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Is Text Company</th>
                    <th>Industry</th>
                    <th>Website</th>
                    <th>Verified</th>
                    <th>Work Email</th>
                    <th>Company Size</th>
                </thead>}

                rows={viewUser.experience.map(org => <tr key={org.userId}>
                    <td>{org.organization}</td>
                    <td>{org.jobTitle}</td>
                    <td>{format(new Date(org.startDate), 'yyyy/MM/dd')}</td>
                    <td>{org.endDate ? format(new Date(org.endDate), 'yyyy/MM/dd') : '-'}</td>
                    <td>{!org.orgId || org.orgId === 'text' ? 'Yes' : 'No'}</td>
                    <td>{org.industry}</td>
                    <td>{org.website}</td>
                    <td>{org.verified}</td>
                    <td>{org.workEmail}</td>
                    <td>{org.company_size_on_linkedin}</td>
                </tr>)}

            />

            <h3>Education Details</h3>


            <Table
                headers={<thead>
                    <th>Uni Name</th>
                    <th>Degree</th>
                    <th>Field</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Is Text Uni</th>
                    <th>Industry</th>
                    <th>Website</th>
                    <th>Verified</th>
                    <th>Work Email</th>
                    <th>Uni Size</th>
                </thead>}

                rows={viewUser.education.map(org => <tr key={org.userId}>
                    <td>{org.university}</td>
                    <td>{org.degree}</td>
                    <td>{org.field}</td>
                    <td>{format(new Date(org.startDate), 'yyyy/MM/dd')}</td>
                    <td>{org.endDate ? format(new Date(org.endDate), 'yyyy/MM/dd') : '-'}</td>
                    <td>{!org.orgId || org.orgId === 'text' ? 'Yes' : 'No'}</td>
                    <td>{org.industry}</td>
                    <td>{org.website}</td>
                    <td>{org.verified}</td>
                    <td>{org.workEmail}</td>
                    <td>{org.company_size_on_linkedin}</td>
                </tr>)}

            />


            <h3>Certifications</h3>


            <Table
                headers={<thead>
                    <th>Name</th>
                    <th>Authority</th>
                    <th>Description</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Is Text</th>

                </thead>}

                rows={viewUser.certification.map(org => <tr key={org.userId}>
                    <td>{org.name}</td>
                    <td>{org.authority}</td>
                    <td>{org.description}</td>
                    <td>{format(new Date(org.startDate), 'yyyy/MM/dd')}</td>
                    <td>{org.endDate ? format(new Date(org.endDate), 'yyyy/MM/dd') : '-'}</td>
                    <td>{!org.orgId || org.orgId === 'text' ? 'Yes' : 'No'}</td>
                </tr>)}

            />

            <h3>Links</h3>

            <Table
                headers={<thead>
                    <th>Name</th>
                    <th>UserId</th>
                    <th>Relation</th>
                    <th>Company</th>
                    <th>Other Company</th>
                    <th>Status</th>
                    <th>Initiated By</th>
                    <th>Initiation Date</th>
                    <th>Approved Date</th>
                </thead>}

                rows={links.map(link => <tr key={link.userId}>
                    <td>{link.user?.firstName} {link.user?.lastName}</td>
                    <td>{link.userId}</td>
                    <td>{link.relation}</td>
                    <td>{link.company}</td>
                    <td>{link.otherCompany}</td>
                    <td>{link.status}</td>
                    <td>{link.pendingBy !== viewUser.id ? `${link.user?.firstName || '-'}` : viewUser.firstName}</td>
                    <td>{format(new Date(link.created * 1000), 'yyyy/MM/dd')}</td>
                    <td>{link.approvedDate ? format(new Date(link.approvedDate * 1000), 'yyyy/MM/dd') : ''}</td>
                </tr>)}

            />

            <h3>Raw Ratings</h3>


            <Table
                headers={<thead>
                    <th>Date</th>
                    <th>Link Name</th>
                    <th>Relationship</th>
                    <th>Company</th>
                    <th>Total Ratings</th>
                    <th>Ratings Count</th>
                    <th>Avg Rating</th>
                    <th>Status of Link</th>
                    <th>Overall Experience</th>
                    <th>Work Again</th>
                    <th>Rating Type</th>
                    <th>Feedback</th>
                    <th>Included In Dashboard</th>
                </thead>}

                rows={rawRatings.map(rating => <tr key={rating._id}>
                    <td>{format(new Date(rating.date), 'yyyy/MM/dd')}</td>
                    <td>{rating.fromUser?.firstName} {rating.fromUser?.lastName}</td>
                    <td>{rating.relation}</td>
                    <td>{rating.company}</td>
                    <td>{rating.ratings.map(r => <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <p style={{ margin: 0 }}>{r.name}:</p>
                        <p style={{ margin: 0 }}>{r.value}</p>
                    </div>)}</td>
                    <td>{rating.ratings.length}</td>
                    <td>{rating.avgRating.toFixed(2)}</td>
                    <td>{rating.status}</td>
                    <td>{findExperienceText(rating.overallExperienceMultiplier)}</td>
                    <td>{rating.interestedMultiplier === 1 ? 'Yes' : 'No'}</td>
                    <td>{rating.original ? 'Original' : 'Updated'}</td>
                    <td>{rating.feedbacks.length > 0 && rating.feedbacks[0]}</td>
                    <td>{checkIfRatingIncludedInStatsBackup(rating)}</td>
                </tr>)}

            />




            <h3>Final Ratings</h3>

            <Table
                headers={<thead>
                    <th>Date</th>
                    <th>Link Name</th>
                    <th>Relationship</th>
                    <th>Company</th>
                    <th>Total Ratings</th>
                    <th>Avg Rating</th>
                    <th>Status</th>
                    <th>Overall Experience</th>
                    <th>Work Again</th>
                </thead>}

                rows={finalRatings.map(rating => <tr key={rating._id}>
                    <td>{format(new Date(rating.date), 'yyyy/MM/dd')}</td>
                    <td>{rating.fromUser?.firstName} {rating.fromUser?.lastName}</td>
                    <td>{rating.relation}</td>
                    <td>{rating.company}</td>
                    <td>{rating.ratings.map(r => <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <p style={{ margin: 0 }}>{r.name}:</p>
                        <p style={{ margin: 0 }}>{r.value}</p>
                    </div>)}</td>
                    <td>{rating.avgRating.toFixed(2)}</td>
                    <td>{rating.status}</td>
                    <td>{findExperienceText(rating.overallExperienceMultiplier)}</td>
                    <td>{rating.interestedMultiplier === 1 ? 'Yes' : 'No'}</td>
                </tr>)}

            />



            <h3>PDF Reports</h3>
            <Table
                headers={<thead>
                    <th>Date</th>
                    <th>Url</th>

                </thead>}

                rows={viewUser.reports ? viewUser.reports.map(rating => <tr key={rating._id}>
                    <td>{format(new Date(rating.date), 'yyyy/MM/dd')}</td>
                    <td > <a href={rating.report} target="_blank">URL</a></td>
                </tr>) : []}

            />


            <h3>Stats Dashboard History</h3>
            {statsBackupRaw.length > 0 && statsBackupRaw.map(row => <div key={row._id} style={{ borderBottom: '1px solid green', marginTop: '20px' }}>
                <p>Date: {row.created && format(new Date(row.created), 'yyyy/MM/dd')}</p>
                <pre>{JSON.stringify(row, undefined, 2)}</pre></div>)}


            <h3>Proxycurl Data</h3>
            {proxyCurlDataProcessed && <pre>{JSON.stringify(proxyCurlDataProcessed, undefined, 2)}</pre>}
        </>
        }
    </div>
}


export default Dashboard